



import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { GoogleMapsService } from '../services/GoogleMaps';

declare var google: any;
declare var require: any;

@Component
export default class Map extends Vue {
  public map: any;
  public markers: any[] = [];
  public userMarker: any = null;
  public userWatcherId: number = -1;
  public selectedLocation: number = -1;

  @Prop() public parkingLocations!: any[];
  @Prop({ default: 0 }) public lat!: number;
  @Prop({ default: 0 }) public lng!: number;

  @Watch('locations')
  public onChildChanged(val: any[], oldVal: any[]) {
    this.drawMarkers(val);
  }

  public initMap() {
    this.$emit('onLoading', true);

    GoogleMapsService.loadGoogleApi().then(async () => {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: this.lat, lng: this.lng },
        zoom: 14,
        disableDefaultUI: true,
        gestureHandling: 'greedy',
      });

      this.$emit('onMapLoad', this.map);

      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        this.$emit('onLoading', false);
      });

      google.maps.event.addListener(this.map, 'dragend', () => {
        const mapCenter = this.map.getCenter();

        //   SearchStore.StoreCoordinates({
        //     lat: mapCenter.lat(),
        //     lng: mapCenter.lng(),
        //   });
      });

      google.maps.event.addListener(this.map, 'click', (e: any) => {
        this.$emit('onMapClick', e);
      });

      const MarkerWithLabel = require('@google/markerwithlabel');
      const positionMarker = new MarkerWithLabel({
        icon: '/assets/images/transparent.png',
        position: new google.maps.LatLng(this.lat, this.lng),
        map: this.map,
        labelAnchor: new google.maps.Point(36 / 2, 47),
        labelClass: 'map-label-position',
        zIndex: 9999,
      });
    });
  }

  public drawMarkers(locations?: any[]) {
    const MarkerWithLabel = require('@google/markerwithlabel');
    const $this = this;

    // if (locations) {
    //   for (let i in locations) {
    //     const location = locations[i];

    //     let markerIndex = this.markers.findIndex(marker => marker.locationId === location.LocationID);

    //     if (markerIndex === -1) {
    //       let marker = new MarkerWithLabel({
    //         icon: '/assets/images/transparent.png',
    //         position: new google.maps.LatLng(location.Latitude, location.Longitude),
    //         map: this.map,
    //         labelContent: '$' + location.Rate,
    //         labelAnchor: new google.maps.Point(58 / 2, 36 / 2),
    //         labelClass: 'map-label',
    //         id: i,
    //         zIndex: parseInt(i),
    //         locationId: location.LocationID,
    //       });

    //       marker.addListener('click', function() {
    //         $this.selectedLocation = location.LocationID;

    //         for (let m of $this.markers) {
    //           m.set('labelClass', 'map-label');
    //           m.set('zIndex', 1000);
    //         }

    //         marker.set('labelClass', 'map-label map-label-active');
    //         marker.set('zIndex', 2000);

    //         $this.$emit('onMarkerClick', { marker: $this.markers[marker.id], location: location });
    //       });

    //       this.markers.push(marker);
    //     } else {
    //       let classes = ['map-label'];

    //       this.markers[i].set('labelContent', '$' + location.Rate);

    //       if (location.Rate === 0) {
    //         classes.push('map-label-disabled');
    //       }

    //       console.log(this.selectedLocation, location.LocationID);
    //       if (location.LocationID === this.selectedLocation) {
    //         classes.push('map-label-active');
    //       }

    //       this.markers[i].set('labelClass', classes.join(' '));

    //       this.markers[i].label.setContent();
    //     }
    //   }
    // }
  }

  public mounted() {
    this.initMap();
  }
}
